import { render } from "./SendMessageDialog.vue?vue&type=template&id=1f68ab10"
import script from "./SendMessageDialog.vue?vue&type=script&lang=js"
export * from "./SendMessageDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__